import React from 'react';

interface LogoOptionsProps {
  isTransparent: boolean;
  onTransparentChange: (value: boolean) => void;
  backgroundColor: string;
  onBackgroundColorChange: (value: string) => void;
  primaryColor: string;
  onPrimaryColorChange: (value: string) => void;
  textColor: string;
  onTextColorChange: (value: string) => void;
  size: number;
  onSizeChange: (value: number) => void;
}

const LogoOptions: React.FC<LogoOptionsProps> = ({ 
  isTransparent, 
  onTransparentChange,
  backgroundColor,
  onBackgroundColorChange,
  primaryColor,
  onPrimaryColorChange,
  textColor,
  onTextColorChange,
  size,
  onSizeChange
}) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center space-x-2">
        <input
          type="checkbox"
          id="transparent-bg"
          checked={isTransparent}
          onChange={(e) => onTransparentChange(e.target.checked)}
          className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
        />
        <label htmlFor="transparent-bg" className="text-sm font-medium text-gray-700">
          Transparent Background
        </label>
      </div>

      {!isTransparent && (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Background Color
          </label>
          <div className="flex items-center space-x-2">
            <input
              type="color"
              value={backgroundColor}
              onChange={(e) => onBackgroundColorChange(e.target.value)}
              className="h-8 w-8 rounded border border-gray-300"
            />
            <input
              type="text"
              value={backgroundColor}
              onChange={(e) => onBackgroundColorChange(e.target.value)}
              className="w-28 px-2 py-1 text-sm border border-gray-300 rounded"
            />
          </div>
        </div>
      )}

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Logo Color
        </label>
        <div className="flex items-center space-x-2">
          <input
            type="color"
            value={primaryColor}
            onChange={(e) => onPrimaryColorChange(e.target.value)}
            className="h-8 w-8 rounded border border-gray-300"
          />
          <input
            type="text"
            value={primaryColor}
            onChange={(e) => onPrimaryColorChange(e.target.value)}
            className="w-28 px-2 py-1 text-sm border border-gray-300 rounded"
          />
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Text Color
        </label>
        <div className="flex items-center space-x-2">
          <input
            type="color"
            value={textColor}
            onChange={(e) => onTextColorChange(e.target.value)}
            className="h-8 w-8 rounded border border-gray-300"
          />
          <input
            type="text"
            value={textColor}
            onChange={(e) => onTextColorChange(e.target.value)}
            className="w-28 px-2 py-1 text-sm border border-gray-300 rounded"
          />
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Logo Size
        </label>
        <div className="flex items-center space-x-4">
          <input
            type="range"
            min="32"
            max="128"
            value={size}
            onChange={(e) => onSizeChange(parseInt(e.target.value))}
            className="w-48"
          />
          <span className="text-sm text-gray-600">{size}px</span>
        </div>
      </div>
    </div>
  );
};

export default LogoOptions;